<div *ngIf="lazyLoadingModule()" class="app-loading">
  <div class="app-loading__panel">
    <app-learning-loader
      [label]="
        lazyLoadingModule() === 'profile'
          ? 'Getting your learning space ready…'
          : 'Opening your next page…'
      "
    ></app-learning-loader>
  </div>
</div>
<div class="w-100">
  <div class="drawer drawer-start">
    <input
      id="side-drawer"
      type="checkbox"
      class="drawer-toggle"
      [(ngModel)]="drawerOpen"
    />
    <div
      class="app-content drawer-content flex flex-col justify-between min-h-screen w-screen"
    >
      <app-header />
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
    <div class="drawer-side z-50">
      <label
        for="side-drawer"
        aria-label="close sidebar"
        class="drawer-overlay"
      ></label>
      <ul class="menu p-4 w-80 min-h-full bg-base-200 text-base-content">
        <li *ngFor="let route of routes">
          <a
            *ngIf="
              !route.permission ||
              route.permission == '' ||
              route.permission == [] ||
              (route.permission | hasRole | async)
            "
            [routerLink]="[route.path]"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLinkActive]="'menu-active'"
            class="menu-item shiney slow"
            (click)="toggleDrawer()"
            >{{ route.path === 'resources' && ('SuperAdmin' | hasRole | async) ? 'All resources' : route.name }}</a
          >
        </li>
        <li>
          <a (click)="openAppModal()" class="menu-item"> Get App </a>
        </li>
      </ul>
    </div>
  </div>
  <button
    *ngIf="quickActionsOpen"
    type="button"
    class="quick-actions-backdrop fixed inset-0 z-30 bg-black/20"
    tabindex="-1"
    aria-label="Close quick actions"
    (click)="closeQuickActions()"
  ></button>
  <div class="fab" [class.fab-open]="quickActionsOpen">
    <button
      #quickActionsToggle
      type="button"
      class="btn btn-circle btn-primary fab-toggle"
      (click)="quickActionsOpen = !quickActionsOpen"
      [attr.aria-expanded]="quickActionsOpen"
      aria-controls="quick-actions"
      [attr.aria-label]="
        quickActionsOpen ? 'Close quick actions' : 'Open quick actions'
      "
      [attr.title]="quickActionsOpen ? 'Close quick actions' : 'Quick actions'"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path *ngIf="quickActionsOpen" d="M6 6l12 12M6 18L18 6" />
        <path
          *ngIf="!quickActionsOpen"
          d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"
        />
      </svg>
    </button>
    <nav
      *ngIf="quickActionsOpen"
      id="quick-actions"
      aria-label="Quick actions"
      class="fab-actions"
    >
      <ng-container *ngFor="let action of desktopQuickActions; let i = index">
        <ng-container
          [ngTemplateOutlet]="quickActionLink"
          [ngTemplateOutletContext]="{
            $implicit: action,
            mobile: false,
            delay: (4 - i) * 30,
          }"
        ></ng-container>
      </ng-container>
    </nav>
  </div>
  <nav
    class="btm-nav btm-nav-lg bottom-menu z-40 rounded-t-2xl border-t border-base-300 text-base-content shadow-lg"
    aria-label="Quick navigation"
  >
    <ng-container *ngFor="let action of mobileQuickActions">
      <ng-container
        [ngTemplateOutlet]="quickActionLink"
        [ngTemplateOutletContext]="{
          $implicit: action,
          mobile: true,
          delay: 0,
        }"
      ></ng-container>
    </ng-container>
  </nav>
</div>

<ng-template #quickActionLink let-action let-mobile="mobile" let-delay="delay">
  <a
    *ngIf="!action.external; else supportLink"
    [routerLink]="action.path"
    [queryParams]="action.search ? { autoFocus: true } : null"
    [routerLinkActive]="mobile ? 'active' : 'is-active'"
    [routerLinkActiveOptions]="{ exact: action.path === '/resources' }"
    ariaCurrentWhenActive="page"
    [class]="mobile ? 'bottom-menu__action hover:bg-base-200' : 'fab-action'"
    [class.bottom-menu__search]="mobile && action.search"
    [style.animation-delay.ms]="delay"
    (click)="closeQuickActions()"
  >
    <ng-container
      [ngTemplateOutlet]="quickActionContent"
      [ngTemplateOutletContext]="{ $implicit: action, mobile: mobile }"
    ></ng-container>
  </a>
  <ng-template #supportLink>
    <a
      [class]="mobile ? 'bottom-menu__action hover:bg-base-200' : 'fab-action'"
      [href]="action.path"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Support Study Heroes on Ko-fi (opens in a new tab)"
      [style.animation-delay.ms]="delay"
      (click)="closeQuickActions()"
    >
      <ng-container
        [ngTemplateOutlet]="quickActionContent"
        [ngTemplateOutletContext]="{ $implicit: action, mobile: mobile }"
      ></ng-container>
    </a>
  </ng-template>
</ng-template>

<ng-template #quickActionContent let-action let-mobile="mobile">
  <span *ngIf="!mobile" class="fab-label">{{ action.path === '/resources' && ('SuperAdmin' | hasRole | async) ? 'All resources' : action.label }}</span>
  <span
    [class]="
      mobile
        ? 'bottom-menu__icon inline-grid h-9 w-9 place-items-center rounded-full'
        : 'btn btn-circle bg-base-100 text-base-content'
    "
    aria-hidden="true"
  >
    <svg
      class="h-6 w-6"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path [attr.d]="action.icon" />
    </svg>
  </span>
  <span
    *ngIf="mobile"
    class="btm-nav-label max-w-full break-words !text-xs font-semibold !leading-tight text-center"
    >{{ action.path === '/resources' && ('SuperAdmin' | hasRole | async) ? 'All resources' : action.label }}</span
  >
</ng-template>

<!-- App Download Modal -->
<dialog #appModal id="links_modal" class="modal" aria-labelledby="modal-title">
  <div class="modal-box" role="document">
    <h3 id="modal-title" class="text-lg font-bold">Download Our App</h3>
    <p class="py-4">
      The app is still in closed beta, we will be launching shortly.
    </p>
    <p class="pb-4">
      Join our mailing list by emailing
      <a
        href="mailto:wave@studyheroes.app?subject=Join%20mailing%20list&body=I%20would%20like%20to%20join%20the%20mailing%20list"
        class="text-red-400 underline hover:text-red-500"
      >
        wave&#64;studyheroes.app
      </a>
    </p>
    <a
      class="btn btn-fast btn-primary font-bold py-2 px-4 focus:outline-none focus:shadow-outline w-full"
      href="mailto:wave@studyheroes.app?subject=Join%20mailing%20list&body=I%20would%20like%20to%20join%20the%20mailing%20list"
    >
      Join Mailing List
    </a>

    <div class="py-4 space-y-4 hidden">
      <a
        href="https://play.google.com/store/apps/details?id=your.app.id"
        target="_blank"
        rel="noopener noreferrer"
        class="btn bg-black border-none p-0 hover:bg-black hover:scale-105 duration-300 w-full h-auto"
        aria-label="Download on Google Play (opens in new tab)"
      >
        <img
          src="assets/images/vendor/google.png"
          alt=""
          class="w-full h-auto object-contain"
          aria-hidden="true"
        />
      </a>
      <a
        href="https://apps.apple.com/us/app/study-heroes/id6471622886"
        target="_blank"
        rel="noopener noreferrer"
        class="btn bg-black border-none p-0 hover:bg-black hover:scale-105 duration-300 w-full h-auto"
        aria-label="Download on App Store (opens in new tab)"
      >
        <img
          src="assets/images/vendor/apple.png"
          alt=""
          class="w-full h-auto object-contain"
          aria-hidden="true"
        />
      </a>
    </div>

    <div class="modal-action">
      <form method="dialog">
        <button class="btn" aria-label="Close modal">Close</button>
      </form>
    </div>
  </div>
</dialog>
